module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/vi/2-66387b6d7efa32096ecc4bca7280ceaf.jpg";